import React from 'react';
import hasLength from 'App/utils/hasLength';
import LookButton from '../LookButton';
import DashboardButton from '../DashboardButton';
import PropTypes from 'prop-types';
import SidebarGroup from 'App/components/SidebarGroup';
import headerRenderer from './headerRenderer';

const propTypes = {
    groupName: PropTypes.string.isRequired,
    dashboards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            title: PropTypes.string.isRequired,
        })
    ),
    looks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            title: PropTypes.string.isRequired,
        })
    ),
};

const defaultProps = {
    dashboards: [],
    looks: [],
};

function GroupList({ groupName, dashboards, looks }) {
    if (!hasLength(dashboards) && !hasLength(looks)) {
        return null;
    }

    return (
        <SidebarGroup headerText={`${groupName} Content`} stateKey={`insights-sidebar-${groupName}`}>
            <div className="group-list">
                {hasLength(dashboards) ? (
                    <SidebarGroup
                        headerText="Dashboards"
                        stateKey={`insights-sidebar-${groupName}-dashboards`}
                        renderHeader={headerRenderer}
                    >
                        <ul className="button-list">
                            {dashboards.map((dash) => {
                                return (
                                    <li key={dash.id}>
                                        <DashboardButton dash={dash} />
                                    </li>
                                );
                            })}
                        </ul>
                    </SidebarGroup>
                ) : null}

                {hasLength(looks) ? (
                    <SidebarGroup
                        headerText="Looks"
                        stateKey={`insights-sidebar-${groupName}-looks`}
                        renderHeader={headerRenderer}
                    >
                        <ul className="button-list">
                            {looks.map((look) => {
                                return (
                                    <li key={look.id}>
                                        <LookButton look={look} />
                                    </li>
                                );
                            })}
                        </ul>
                    </SidebarGroup>
                ) : null}
            </div>
        </SidebarGroup>
    );
}

GroupList.propTypes = propTypes;
GroupList.defaultProps = defaultProps;

export default GroupList;
